import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from '../ui/BrandMark';
import '../landing/landing.css';
import './static.css';

const DEFAULT_DOCUMENT_TITLE = 'QPrice — Партнёрский кабинет';

interface StaticPageLayoutProps {
  kicker: string;
  title: string;
  documentTitle: string;
  updatedAt?: string;
  children: React.ReactNode;
}

export const StaticPageLayout: React.FC<StaticPageLayoutProps> = ({
  kicker,
  title,
  documentTitle,
  updatedAt,
  children,
}) => {
  useEffect(() => {
    document.title = documentTitle;
    window.scrollTo(0, 0);
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [documentTitle]);

  return (
    <div className="qp-landing">
      <div className="qp-grain" aria-hidden />

      <nav className="qp-nav">
        <Link to="/" className="qp-wordmark" style={{ color: 'inherit', textDecoration: 'none' }}>
          <BrandMark className="qp-wordmark-mark" />
          QPRICE
        </Link>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <a
            href="tel:+77772468483"
            className="qp-nav-link"
            style={{ textDecoration: 'none' }}
            aria-label="Позвонить в поддержку"
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden>
              <path d="M3 3.5A1.5 1.5 0 014.5 2h1.65a1 1 0 01.97.757l.6 2.4a1 1 0 01-.27.95L6.3 7.26a8 8 0 003.44 3.44l1.15-1.15a1 1 0 01.95-.27l2.4.6a1 1 0 01.76.97V12.5A1.5 1.5 0 0113.5 14a11 11 0 01-10.5-10.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
            <span className="qp-nav-phone-full">+7 777 246 84 83</span>
            <span className="qp-nav-phone-short">Позвонить</span>
          </a>
          <Link to="/login" className="qp-nav-link" style={{ textDecoration: 'none' }}>
            Войти
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
              <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </nav>

      <main className="qp-static-main">
        <p className="qp-static-kicker">{kicker}</p>
        <h1 className="qp-static-title">{title}</h1>
        {updatedAt && <p className="qp-static-updated">Редакция от {updatedAt}</p>}
        {children}
      </main>

      <footer className="qp-footer">
        <span>© {new Date().getFullYear()} QPrice · Алматы, Астана и ещё 12 городов</span>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'center' }}>
          <Link to="/support" style={{ color: 'var(--qp-ink-soft)', textDecoration: 'none' }}>
            Поддержка
          </Link>
          <Link to="/terms/clients" style={{ color: 'var(--qp-ink-muted)', textDecoration: 'none' }}>
            Соглашение для клиентов
          </Link>
          <Link to="/terms/partners" style={{ color: 'var(--qp-ink-muted)', textDecoration: 'none' }}>
            Оферта для партнёров
          </Link>
          <Link to="/ugc-rules" style={{ color: 'var(--qp-ink-muted)', textDecoration: 'none' }}>
            Правила публикации
          </Link>
          <Link to="/privacy" style={{ color: 'var(--qp-ink-muted)', textDecoration: 'none' }}>
            Конфиденциальность
          </Link>
        </div>
      </footer>
    </div>
  );
};
